import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import Table from '../../components/Table'
import Sidebar from '../../components/Sidebar'
import Header from '../../components/Header'
import Modal from '../../components/Modal'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import { HistoricModal } from '../../components/Inventory'
import { Grid, Content } from '../../components/Layout'
import { inventoryActions } from '../../actions'
import { pxToRem, color } from '../../utils'
import historicIcon from '../../assets/icons/history-solid.svg'
import ContentHeader from '../../components/ContentHeader'

const HistoricContent = styled.div``

const WrapperButton = styled.div`
  margin-bottom: ${pxToRem(10)};
  display: block;
  text-align: left;
  width: 100%;
  div {
    vertical-align: bottom;
  }
  h2 {
    font-size: ${pxToRem(16)};
    display: block;
    margin-top: 0;
    margin-bottom: 0;
  }
`

const WrapperExportButton = styled.div`
  h2 {
    font-size: ${pxToRem(16)};
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
  }
  a {
    font-size: ${pxToRem(16)};
    color: ${color.secondary};
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    &:visited {
      color: ${color.secondary};
    }
  }
`

const WrapperActions = styled.div`
  text-align: center;
`

const Action = styled.img`
  width: ${pxToRem('25px')};
  height: 20px;
  margin: 5px;
  display: inline-block;
  cursor: pointer;
`

const HistoricLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const ExportLink = styled.i`
  cursor: pointer;
  font-size: ${pxToRem(16)};
  color: ${color.secondary};
  display: inline-block;
  text-decoration: underline;
  &:visited {
    color: ${color.secondary};
  }
`

const ExportXls = styled(ExportLink)`
  margin-right: 5px;
`

const ExportPdf = styled(ExportLink)`
  margin-left: 5px;
`

const columns = {
  id: {
    hide: true
  },
  product_id: {
    hide: true
  },
  name: {
    label: 'Produto',
    width: pxToRem(500)
  },
  batch: {
    label: 'Lote / Identificação',
    sortable: true,
    width: pxToRem(20)
  },
  input_date: {
    label: 'Data Entrada',
    sortable: true,
    width: pxToRem(20)
  },
  output_date: {
    label: 'Data Saída',
    sortable: true,
    width: pxToRem(20)
  },
  actions: {
    label: 'Ações',
    align: 'center',
    width: pxToRem(90)
  }
}

class Historic extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounce: undefined,
      openHistoricModal: false,
      productId: null,
      productBatch: null
    }
  }

  componentDidMount() {
    this.props.fetchInventoryHistoric(this.props.areaId)
  }

  componentDidUpdate(prevProps) {
    if (this.props.areaId && prevProps.areaId !== this.props.areaId) {
      const debounce = setTimeout(() => {
        this.props.fetchInventoryHistoric(this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  componentWillUpdate({ searchText = '' }) {
    if (searchText !== this.props.searchText) {
      const debounce = setTimeout(() => {
        this.props.fetchSearch(searchText, this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  openModalHistoric = async (
    row = undefined,
    areaId,
    page = 1,
    rowsPerPage = 10,
    orderBy = 'created_at',
    order = 'desc'
  ) => {
    const object = {
      product_id: row.product_id,
      batch: row.batch,
      areaId,
      page,
      rowsPerPage,
      orderBy,
      order
    }
    if (row && row.product_id) {
      await this.getHistoricModalData(object)
    } else {
      this.clearInventoryState()
    }
    this.setState(state => ({ openHistoricModal: true, productId: row.product_id, productName: row.name, productBatch: row.batch }))
  }

  getHistoricModalData = async object => {
    const response = await inventoryActions.getProductHistoric(object)
    this.setState(state => ({
      historicData: response.items,
      paginationHistoric: response.pagination
    }))
  }

  closeModalHistoric = () => {
    this.setState(state => ({
      openHistoricModal: false
    }))
  }

  downloadXls = () => {
    this.props.fetchHistoricDownloadXls(this.props.areaId)
  }

  downloadPdf = () => {
    this.props.fetchHistoricDownloadPdf(this.props.areaId)
  }

  onChangeRowsPerPage = (rowsPerPage, currentPage = 1, orderBy, order) => {
    this.props.fetchInventoryHistoric(this.props.areaId, currentPage, rowsPerPage, orderBy, order)
  }

  onChangePage = (newPage, rowsPerPage, orderBy, order) => {
    this.props.fetchInventoryHistoric(this.props.areaId, newPage, rowsPerPage, orderBy, order)
  }

  onChangeOrderBy = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    if (orderBy === 'batchCurrentStock') {
      orderBy = 'amount'
    }
    this.props.fetchInventoryHistoric(this.props.areaId, currentPage, rowsPerPage, orderBy, order)
  }

  onChangeRowsPerPageHistoric = (
    rowsPerPage,
    currentPage = 1,
    orderBy = 'created_at',
    order = 'desc'
  ) => {
    const object = {
      product_id: this.state.productId,
      batch: this.state.productBatch,
      areaId: this.props.areaId,
      page: currentPage,
      rowsPerPage,
      orderBy,
      order
    }
    this.getHistoricModalData(object)
  }

  onChangePageHistoric = (
    newPage,
    rowsPerPage,
    orderBy = 'created_at',
    order = 'desc'
  ) => {
    const object = {
      product_id: this.state.productId,
      batch: this.state.productBatch,
      areaId: this.props.areaId,
      page: newPage,
      rowsPerPage,
      orderBy,
      order
    }
    this.getHistoricModalData(object)
  }

  onChangeOrderByHistoric = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    if (orderBy === 'batchCurrentStock') {
      orderBy = 'amount'
    }
    const object = {
      product_id: this.state.productId,
      batch: this.state.productBatch,
      areaId: this.props.areaId,
      page: currentPage,
      rowsPerPage,
      orderBy,
      order
    }
    this.getHistoricModalData(object)
  }

  productFullName = product => {
    const provider =
      product && product.provider && product.provider !== '---'
        ? ' - (' + product.provider + ')'
        : ''
    return product.name + provider
  }

  render() {
    const {
      areaId,
      changeStatusDownloadError,
      fetch_errors,
      fetching,
      fetchInventoryHistoric,
      inventoryHistoric,
      last_update,
      menuItems,
      pagination,
      router
    } = this.props

    const {
      openHistoricModal,
      productName,
      productId,
      productBatch,
      historicData,
      paginationHistoric
    } = this.state

    const {
      openModalHistoric,
      closeModalHistoric,
      downloadXls,
      downloadPdf,
      onChangeRowsPerPage,
      onChangePage,
      onChangeOrderBy,
      onChangePageHistoric,
      onChangeRowsPerPageHistoric,
      onChangeOrderByHistoric,
      productFullName
    } = this

    const NameCellComponent = ({ name, value, row, ...rest }) => {
      return (
        <HistoricLink {...rest} onClick={e => openModalHistoric(row, areaId)}>
          {value}
        </HistoricLink>
      )
    }

    columns['name'] = {
      ...columns['name'],
      CellComponent: NameCellComponent
    }

    const ActionsCellComponent = ({ name, value, row, ...rest }) => {
      return (
        <WrapperActions>
          <Action src={historicIcon} onClick={e => openModalHistoric(row, areaId)} />
        </WrapperActions>
      )
    }

    columns['actions'] = {
      ...columns['actions'],
      CellComponent: ActionsCellComponent
    }

    return (
      <Fragment>
        <Grid>
          <Header search router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content scapeSearch>
            <ContentHeader
              title="Produtos Químicos"
              subtitle="Histórico"
              last_update={last_update}
            >
            </ContentHeader>
            <HistoricContent>
              <WrapperButton>
                <h2>Exportar Para: </h2>
                <WrapperExportButton>
                  <ExportXls
                    onClick={e => {
                      downloadXls()
                    }}
                  >
                    EXCEL
                  </ExportXls>
                  |
                  <ExportPdf
                    onClick={e => {
                      downloadPdf()
                    }}
                  >
                    PDF
                  </ExportPdf>
                </WrapperExportButton>
              </WrapperButton>
              <Table
                loading={fetching.inventoryHistoric}
                error={fetch_errors.inventoryHistoric}
                fetchData={fetchInventoryHistoric}
                columns={columns}
                height={'55vh'}
                width={1100}
                data={inventoryHistoric.map(item => {
                  return {
                    ...item,
                    name: productFullName(item)
                  }
                })}
                pagination={pagination}
                defaultSort={{ key: 'id', reverse: true }}
                onChangePage={(newPage, rowsPerPage) => onChangePage(newPage, rowsPerPage)}
                onChangeRowsPerPage={(rowsPerPage, currentPage) =>
                  onChangeRowsPerPage(rowsPerPage, currentPage)
                }
                onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                  onChangeOrderBy(orderBy, order, currentPage, rowsPerPage)
                }
              />
              <HistoricModal
                title="Histórico do Produto"
                open={openHistoricModal}
                closeMethod={closeModalHistoric}
                size="large"
                loading={false}
                productName={productName}
                productId={productId}
                productBatch={productBatch}
                historicData={historicData}
                pagination={paginationHistoric}
                onChangePage={(newPage, rowsPerPage) => onChangePageHistoric(newPage, rowsPerPage)}
                onChangeRowsPerPage={(rowsPerPage, currentPage) =>
                  onChangeRowsPerPageHistoric(rowsPerPage, currentPage)
                }
                onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                  onChangeOrderByHistoric(orderBy, order, currentPage, rowsPerPage)
                }
              />
            </HistoricContent>
            <ResponsiblesContent />
          </Content>
        </Grid>
        <Modal
          safeContent={false}
          loading={false}
          open={fetch_errors.download}
          size={'small'}
          error={true}
          errorMessage={'Falha ao exportar o arquivo'}
          closeMethod={changeStatusDownloadError}
        />
        <Modal
          safeContent={false}
          loading={fetching.download}
          open={fetching.download}
          size={'small'}
          error={false}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  areaId: state.auth.areaId,
  fetch_errors: state.inventory.fetch_errors,
  fetching: state.inventory.fetching,
  inventoryHistoric: state.inventory.items,
  last_update: state.inventory.last_update,
  pagination: state.inventory.pagination,
  searchText: state.search.searchText
})

const mapDispatchToProps = dispatch => {
  return {
    fetchInventoryHistoric: (
      areaId,
      page = 1,
      rowsPerPage = 10,
      orderBy = 'input_date',
      order = 'desc',
      searchText = ''
    ) => {
      dispatch(inventoryActions.fetchInventoryHistoric({ areaId, page, rowsPerPage, orderBy, order, searchText }))
    },
    fetchSearch: (
      searchText = '',
      areaId,
      page = 1,
      rowsPerPage = 10,
      orderBy = 'input_date',
      order = 'desc'
    ) => {
      dispatch(inventoryActions.fetchInventoryHistoric({ areaId, page, rowsPerPage, orderBy, order, searchText }))
    },
    fetchHistoricDownloadPdf: areaId => {
      dispatch(inventoryActions.fetchHistoricDownloadPdf(areaId))
    },
    fetchHistoricDownloadXls: areaId => {
      dispatch(inventoryActions.fetchHistoricDownloadXls(areaId))
    },
    changeStatusDownloadError: () => {
      dispatch(inventoryActions.changeStatusDownloadError())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Historic)



// WEBPACK FOOTER //
// ./src/containers/Inventory/Historic.js